import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from 'react-tooltip'
import Icon from 'components/Icon';
import Button from 'components/Button';


const IconButton = ({
  icon,
  iconSource,
  iconOptions,
  className,
  tooltip,
  tooltipHtml,
  tooltipDelayShow,
  disabled,
  ...props
}) => {
  return (
    <Wrapper className={className}>
      {(tooltip || tooltipHtml) && <Tooltip id={`icon-btn-tooltip`} className='icon-btn-tooltip' />}
      <Button
        data-tooltip-id={`icon-btn-tooltip`}
        data-tooltip-content={tooltip}
        data-tooltip-html={tooltipHtml}
        data-tooltip-delay-show={tooltipDelayShow}
        styleType='icon'
        disabled={disabled}
        {...props}
      >
        <Icon
          name={icon}
          source={iconSource}
          options={iconOptions}
        />
      </Button>
    </Wrapper>
  );
}

export default styled(IconButton)`
`;

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  iconSource: PropTypes.string,
  className: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipHtml: PropTypes.string,
  tooltipDelayShow: PropTypes.number,
  iconOptions: PropTypes.shape(PropTypes.any),
};

IconButton.defaultProps = {
  tooltipDelayShow: 500
};

const Wrapper = styled.div`
  &:hover {
    color: var(--lizzy-black);
    opacity: .6;
  }

  .icon-btn-tooltip {
    z-index: 142;
  }

  .icon-btn-tooltip {
    padding: 2px 6px;
  }

  ${Button}:disabled {
    background-color: transparent;
    opacity: 0.6;
  }
`;